import { activateTrialServer } from '@/actions/trials';
import { getUserAccessToken } from '@/utils/account/getUserAccessToken';

export const activateTrial = async (trialId: string): Promise<void> => {
  const userAccessToken = await getUserAccessToken();
  return activateTrialServer(userAccessToken, trialId);
};
